export const LEAD_CHANGE_STEP = "CHANGE_STEP";
export const LEAD_SET_STEP_LOADING = "SET_STEP_LOADING";
export const LEAD_SET_SUBMITTING = "SET_SUBMITTING";
export const LEAD_SET_SUBMIT_ERROR = "SET_SUBMIT_ERROR";
export const LEAD_SET_FIELDS = "SET_FIELDS";
export const LEAD_SET_LEAD_ID = "SET_LEAD_ID";
export const LEAD_SET_IS_OTP_STEP = "SET_IS_OTP_STEP";
export const LEAD_SET_PREFILL_FIELD = "SET_PREFILL_FIELD";
export const LEAD_SET_FORM_ERRORS = "LEAD_SET_FORM_ERRORS";
